import React from 'react';
import { BaseTable } from './BaseTable';
import { TableCaptionCell, TableCell } from './Table';

const captions = ['Checkouts', 'Inspects', 'Avg total', 'Shows', 'Closes'];

export const StandardTable: React.FC = () => (
  <BaseTable
    description="Main statistics"
    restCaptionsPart={
      <>
        {captions.map((caption) => (
          <TableCaptionCell>{caption}</TableCaptionCell>
        ))}
      </>
    }
    restRowPart={(tableRow) => (
      <>
        <TableCell>{tableRow.stats.checkout}</TableCell>
        <TableCell>{tableRow.stats.show}</TableCell>
        <TableCell>{tableRow.stats.avgTotal}</TableCell>
        <TableCell>{tableRow.stats.showSlider}</TableCell>
        <TableCell>{tableRow.stats.closeSlider}</TableCell>
      </>
    )}
  />
);
